import { BaseStore, Config, Product } from '@spartacus/core';
import { makeStateKey } from '@angular/core';

import { WebCommonConfig } from '../config/configs/web-common.config';
import { CssHierarchy } from '../models/css-hierarchy.model';
import { UrlMapping } from '../models/url-mapping.model';
import { Recipe } from '../models/recipe.model';
import { Bundle } from '../models/bundle.model';

export const HIERARCHY_KEY = makeStateKey<{ [key: string]: CssHierarchy }>('cssHierarchy');
export const WEB_CONFIG_KEY = makeStateKey<WebCommonConfig>('webConfig');
export const SRV_CONFIG_KEY = makeStateKey<Config>('serverConfig');
export const GEOLOCATION_KEY = makeStateKey<string>('geolocationKey');
export const BASESTORE_KEY = makeStateKey<BaseStore>('baseStore');

export const RECIPES_KEY = makeStateKey<Recipe[]>('recipes');
export const FIRST_RECIPE_VARIANT_KEY = makeStateKey<Recipe>('firstRecipeVariant');

export const URL_MAPPING_KEY = makeStateKey<UrlMapping[]>('urlMappings');

export const PRODUCT_OR_BUNDLE_STATE_KEY = makeStateKey<{ product?: Product; bundle?: Bundle }>('productOrBundle');
